import localeAntd from 'ant-design-vue/lib/locale-provider/en_US'

const messages = {
  topBar: {
    issuesHistory: 'Issues History',
    projectManagement: 'Project Management',
    typeToSearch: 'Search...',
    findPages: 'Find pages...',
    actions: 'Actions',
    status: 'Status',
    profileMenu: {
      hello: 'Hello',
      billingPlan: 'Billing Plan',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      // editProfile: 'Edit Profile',
      logout: 'Logout',
    },
    myStore: 'My Store',
  },
  sideBar: {
    dashboard: 'Dashboard',
    sales: 'Sales',
    orderList: 'Order List',
    commissionList: 'Commission List',
    orderListDistributor: 'Sale List',
    store: 'Store',
    availableProducts: 'Available Products',
    myProducts: 'My Products',
    setting: 'Setting',
    viewStore: 'View Store',
    account: 'Account',
    editProfile: 'Edit Profile',
    ewalletHistory: 'E-wallet History',
    withdrawRequest: 'Withdraw Request',
    purchase: 'Purchase Order',
    purchaseList: 'Purchase List',
    createPurchase: 'Create Purchase',
    purchaseCatalogue: 'Catalogue',
  },
  authForm: {
    loginFailed: 'Login Failed',
    registerFailed: 'Register Failed',
    invalidPassword: 'Invalid Password',
    invalidPasswordOrUsername: 'You have entered an invalid email or password',
    emailNotFound: 'User Email Not Found',
    systemBusy:
      'System seems to be busy, please try again later or contact administrator!',
    tankYou: 'Tank You',
    forgotpassSucces: 'Please check your email for completing reset password',
    forgotpassFailed: 'Forgot Password Failed',
    passwrdNotmatch: 'Password is different!',
    resetpassFailed: 'Reset Password Failed',
    resetpassSuccess: 'Reset Password Success',
    loginTitle: 'Reseller Dropshipper',
    signInDesc: 'Sign in to your account',
    requiredEmail: 'Please input your Email address!',
    formatEmail: 'Your Email address is invalid',
    requiredPassword: 'Please input your Password!',
    signIn: 'Sign In',
    // eslint-disable-next-line
    dontHaveAccount: `Don't have an account?`,
    register: 'Register',
    forgotPassword: 'Forgot Password?',
    resetPass: 'Reset Password',
    resetMyPass: 'Reset my password',
    emailAddress: 'Email Address',
    goToSignIn: 'Go to sign in',
    newPass: 'New Password',
    confirmNewPass: 'Confirm New Password',
    createAccount: 'Create your account',
    firstName: 'First Name',
    requiredFirstName: 'Please input your first name',
    lastName: 'Last Name',
    requiredLastName: 'Please input your last name',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    toc: 'By signing up, you agree to the',
    and: 'and',
    alreadyHaveAccount: 'Already have an account?',
    registerSuccess:
      'Please check your Email: {email} for completing your registration.',
    regConfirmation: 'Register Confirmation',
    storeName: 'Store Name',
    requiredStoreName: 'Please input your store name',
    validator: 'Only "-" sign is allowed',
    storeUrl: 'Store Url',
    helpStoreUrl:
      'Please make sure your url store. you cant change store url after register',
    requiredStoreUrl: 'Please input your store URL',
    phoneNumber: 'Phone Number',
    requiredPhoneNumber: 'Please input your phone number. Use number instead',
    address: 'Address',
    requiredAddress: 'Please input your address',
    address2: 'Address 2',
    requiredAddress2: 'Please input your address (optional)',
    country: 'Country',
    city: 'City',
    placeCity: 'Select a City',
    area: 'Area',
    placeArea: 'Select a Area',
    zip: 'Zip',
    requiredZip: 'Zip code value must be a number',
    bankInformation: 'Bank Information',
    accountNo: 'Account No.',
    requiredAccountNo: 'Account number value must be a number',
    accountHolder: 'Account Holder Name',
    placeAccountHolder: 'Please input your bank account name',
    bankAccount: 'Bank Account',
    placeBankAcc: 'Select a bank',
    idCard: 'ID Card (KTP/SIM)',
    popUpRemoveImage: 'Are you sure want to remove this image ?',
    removeImage: 'Remove Image',
    toc2: 'I agree with term and condition.',
    submitConRegister: 'Submit',
    registerCompleted: 'Register Completed',
    requiredCity: 'Please select a city',
    requiredArea: 'Please select area',
    requiredBankAcc: 'Please select bank account',
    requiredBankAccName: 'Please input your bank account name',
    requiredToc2: 'Please check term and condition',
    extraNpwp:
      'If you have a NPWP, the commission you get will be deducted by 5% tax, otherwise 6% will be deducted',
  },
  dashboard: {
    weeklySales: 'Weekly Sales',
    onProcess: 'On Process Orders',
    completedOrders: 'Completed Orders',
    refundRequest: 'Refund Request',
    ewallet: 'E-wallet',
    totalCommission: 'Total Commission',
    onComingCommission: 'Commisions  On Coming Transaction',
    bestSeller: 'Best Seller Items',
    productNotFound: 'Product Not Found',
    lastSoldItems: 'Last Sold Items',
  },
  sales: {
    date: 'Date',
    orderNumber: 'Order Number',
    productName: 'Product Name',
    commission: 'Commission',
    searchResult: 'Result',
    searchCommission: 'Search by Order Number',
    search: 'Search',
    notifSearch: 'Please input range date or order number',
    orderNumberDate: 'Order Number and Date',
    customerNameAddress: 'Customer Name and Address',
    status: 'Status',
    actions: 'Actions',
    all: 'All',
    onComingCommission: 'On Coming Commission',
    finishedOrdered: 'Finished Order',
    cancelRequest: 'Cancel Request',
    canceled: 'Canceled',
    customerInfo: 'Customer Info',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    paymentInformation: 'Payment Information',
    totalPayment: 'Total Payment',
    totalShop: 'Total Payment',
    paymentStatus: 'Payment Status',
    paymentMethod: 'Payment Method',
    shippingInforamtion: 'Shipping Information',
    amount: 'Amount',
    totalItemPrice: 'Total Item Price',
    shippingCost: 'Shipping Cost',
    insuranceCost: 'Insurance Cost',
    voucher: 'Voucher',
    discount: 'Discount',
    total: 'Total',
    waitingPayment: 'Waiting Payment',
  },
  store: {
    allProduct: 'All Product',
    selectAll: 'Select All',
    addToStore: 'Add To Store',
    removeFromStore: 'Remove from Store',
    searchProduct: 'Search by product title',
    productInStore: 'Product in Store',
    productOutStore: 'Product not in Store',
    productNotFound: 'Product Not Found',
    loadMore: 'Load More',
    alreadyInStore: 'In store',
    price: 'Price for {value} variant',
    commission: 'Commission',
    fotoProfile: 'Store Foto Profile',
    changeImage: ' Change Image',
    addImage: 'Add Image',
    storeName: 'Store Name',
    requiredStoreName: 'Please input your store name',
    notifStoreUrl: 'You cant change url store',
    save: 'Save',
    selectedBanner: 'Selected Banner:',
    availableBanner: 'Available Banner:',
    profileSetting: 'Store Profile Settings',
    bannerSetting: 'Banner Settings',
    storeUrl: 'Store Url',
    successAddProduct: 'Add product to store success',
    failedAddProduct: 'Remove product from store success',
    successRemoveProduct: 'Remove product from store success',
    failedRemoveProduct: 'Remove product from store failed',
    successEditStore: 'Edit store profile success',
    failedEditStore: 'Edit store profile failed',
    requiredStoreFoto: 'Please input your store foto',
    outOfStock: 'Out of Stock',
    shareThisProduct: 'Share this Product',
    shareProduct: 'Share Product {value}',
    extraDefaultMessage:
      'if you dont create a message, we will create a default message.',
    placeholderDefaultMessage: 'Set your message (optional)',
    shareWith: 'Share with',
    changeDefaultMessage:
      '*You can change the default message. create your own message below',
    stock: 'Stock',
    updateStock: 'Update stock',
    color: 'Color',
    size: 'Size',
    flavour: 'Flavour',
    saveChanges: 'Save changes',
    changeStockSuccess: 'Stock successfully updated',
  },
  account: {
    firstName: 'First Name',
    requiredFirstName: 'Please input your first name',
    lastName: 'Last Name',
    requiredLastName: 'Please input your last name',
    phoneNumber: 'Phone Number',
    requiredPhoneNumber: 'Please input your phone number',
    address: 'Address',
    requiredAddress: 'Please input your address',
    address2: 'Address 2',
    requiredAddress2: 'Please input your address (optional)',
    city: 'City',
    area: 'Area',
    addBank: 'Add Bank Account',
    bankInformation: 'Bank Information',
    accountNo: 'Account No.',
    accountHolder: 'Account Holder Name',
    inputData: 'Please Input Data',
    bankAccount: 'Bank Account',
    changeBank: 'Change Bank Account',
    ewalletSaldo: 'E-wallet saldo',
    withdrawAmount: 'Withdraw amount',
    helpWithdraw: 'Minimum E-wallet saldo for transaction Rp. {value}',
    dataCorrect: 'All data is correct',
    notifSuccessWithdraw: 'Withdraw Request Completed',
    notifSuccessWithdraw2:
      'Transfer process will take no later than 1 × 24 working hours',
    successEditProfile: 'Edit Profile Success',
    failedEditProfile: 'Edit Profile Failed',
    requiredFotoProfile: 'Please Input Your Foto Profile',
    editBankSuccess: 'Edit Bank Account Success',
    editBankFailed: 'Edit Bank Account Failed',
    addBankSuccess: 'Add Bank Account Success',
    addBankFailed: 'Add Bank Account Failed',
    modalDeleteBank: 'Do you want to delete these Bank Account?',
    deleteBankSuccess: 'Delete Bank Account Success',
    deleteBankFailed: 'Delete Bank Account Failed',
    notEnoughEwallet: 'your balance is not enough',
    minimumEwallet: 'Minimum withdrawal amount Rp. {value}',
    totalEwalletAmmount: 'Total Ewallet to withdraw:',
    willTransfer: 'Will transfer to:',
    changeImageNpwp: 'Change NPWP',
    addImageNpwp: 'Add NPWP',
    noData: 'Data not Found',
    all: 'All',
    commission: 'Commission',
    withdraw: 'Withdraw',
    tax: 'Tax',
    editBank: 'Edit Bank Account',
    lastWithdraw: 'Last Withdraw',
    date: 'Date',
    status: 'Status',
    withdrawEwallet: 'Withdraw Ewallet',
  },
  purchase: {
    payment: {
      information: 'Payment Information',
      total: 'Payment Total',
      status: 'Payment Status',
      method: 'Payment Method',
      reference: 'Payment Reference',
      instructions: 'Payment Instructions',
    },
    state: {
      created: 'Order Created',
      canceled: 'Canceled',
      paid: 'Order already paid',
      waitingPayment: 'Waiting payment',
      payment: 'Payment',
      paymentExpired: 'Payment expired',
      expired: 'Payment expired',
      processing: 'On Process',
      shipping: 'Shipping',
      shipped: 'Shipped',
      delivered: 'Delivered',
      notDeliveredYet: 'Not received yet',
      finish: 'Finish',
    },
    shipping: {
      information: 'Shipping Information',
      name: 'Consignee name',
      phone: 'Consignee phone',
      address: 'Consignee address',
      detail: 'Shipping Detail',
      change: 'Change Shipping Data',
      select: 'Select Shipping Data',
      method: 'Shipping Method',
    },
    billing: {
      change: 'Change Billing Data',
      select: 'Select Billing Data',
    },
    awb: 'AWB No.',
    courier: 'Courier',
    poNumber: 'PO Number',
    orderNumber: 'Order Number',
    createdAt: 'Order Date',
    deliveryExpectations: 'Delivery Expectations',
    total: 'Total Value',
    note: 'Note',
    createNew: 'Create New',
    addProduct: 'Add Product',
    price: 'Price',
    discount: 'Discount',
    nomralPrice: 'Normal Price',
  },
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
